import React, { useState, useRef } from 'react';
import './Products.css';

const Products = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const products = [
    {
      id: 1,
      name: 'Farm Fresh A2 Milk',
      description: 'Premium A2 milk from specially selected cows, easy to digest and nutritious.',
      price: '₹80',
      quantity: '/L',
      image: '/product-images/farmfresha2milk.png',
      details: 'Our Farm Fresh A2 Cow Milk is sourced directly from our own well-maintained farms and delivered fresh to your doorstep. Carefully processed using modern hygienic methods, it retains its natural goodness while ensuring complete safety for everyday consumption.',
      benefits: ['Naturally rich in A2 protein for easy digestion', '100% antibiotic-free and oxytocin-free', 'Supports daily nutrition for all age groups', 'Fresh taste with no artificial additives', 'Hygienically pasteurized for safety and purity'],
      availableIn: ['500ml'],
      keyIngredients: ['100% Pure A2 Cow Milk'],
      directions: ['Consume fresh after boiling, if preferred', 'Ideal for daily drinking, tea, coffee, curd preparation, and cooking', 'Best enjoyed as part of your morning or evening routine'],
      safety: ['Pasteurized and processed in a fully hygienic, hands-free environment', 'Store refrigerated at 4°C or below', 'Consume within the recommended period mentioned on the pack', 'Shake well before use']
    },
    {
      id: 2,
      name: 'Pasteurized Cow Milk',
      description: 'Safe, nutritious, and fresh pasteurized milk for your family.',
      price: '₹60',
      quantity: '/L',
      image: '/product-images/pasteurizedcowmilk.png',
      details: 'Our pasteurized cow milk undergoes a gentle heating process to ensure safety while preserving its natural nutrients and taste. Perfect for children and adults alike for daily consumption.',
      benefits: ['Safe & Clean', 'Nutrient Rich', 'Fresh Daily', 'Versatile'],
      availableIn: ['500ml', '1L'],
      keyIngredients: ['Pasteurized Cow Milk'],
      directions: ['Consume chilled or warm', 'Refrigerate after purchase'],
      safety: ['Keep refrigerated', 'Use within 2 days', 'Contains dairy']
    },
    {
      id: 3,
      name: 'A2 Cow Ghee',
      description: 'Traditional clarified butter made from pure A2 milk for authentic flavor.',
      price: '₹850',
      quantity: '/500g',
      image: '/product-images/a2ghee.png',
      details: 'Ayodhya A2 Cow Ghee is crafted the traditional way, by hand-churning A2 curd, not cream, using wooden bilonas during the serene hours of Brahma Muhurta. The butter obtained is slowly clarified over a gentle flame, resulting in a rich, grainy, golden ghee rooted in Vedic purity. This is not just ghee; it is a time-honored process transformed into nourishment for modern living.',
      benefits: ['Made from A2 cow milk curd using the traditional bilona method', 'Rich in essential nutrients that support holistic wellness', 'Naturally aromatic, grainy, and golden in texture', 'Supports digestion, immunity, and overall vitality', 'Free from chemicals, preservatives, and artificial processing'],
      availableIn: ['(To be updated as per packaging)g'],
      keyIngredients: ['100% A2 Cow Milk Curd'],
      directions: ['Use for daily cooking, sautéing, or tempering', 'Ideal for traditional recipes, rituals, and wellness routines', 'Can be consumed directly in small quantities as part of a balanced diet'],
      safety: ['Prepared in a controlled, hygienic environment following traditional practices', 'Store in a cool, dry place away from direct sunlight', 'Always use a clean, dry spoon', 'Natural variation in texture and aroma may occur due to traditional processing']
    },
    {
      id: 4,
      name: 'Curd',
      description: 'Creamy, probiotic-rich curd for better digestion and health.',
      price: '₹50',
      quantity: '/500g',
      image: '/product-images/curd.png',
      details: 'Our Fresh Dahi is carefully cultured to achieve the perfect balance of thickness and creaminess. Made using high-quality milk and traditional setting methods, it delivers a naturally rich taste that feels just like homemade curd—fresh, wholesome, and satisfying.',
      benefits: ['Thick and creamy texture with a smooth mouthfeel', 'Naturally delicious, with no artificial thickeners', 'Easy to digest and gut-friendly', 'Perfect companion for everyday meals and recipes', 'Freshly prepared for consistent quality and taste'],
      availableIn: ['Cups: 200g, 400g', '5Pouches: 200g, 500g, 1kg'],
      keyIngredients: ['Pure Milk', 'Natural Curd Culture'],
      directions: ['Enjoy directly as a side with meals', 'Use for preparing raita, kadhi, chaas, or desserts', 'Ideal for cooking, marination, or daily consumption'],
      safety: ['Prepared and packed under strict hygienic conditions', 'Store refrigerated at 4°C or below', 'Do not consume if the pack is bloated or damaged', 'Use within the recommended period mentioned on the pack']
    },
    {
      id: 5,
      name: 'Ayodhya Malai Paneer',
      description: 'Soft and fresh cottage cheese made daily from pure milk.',
      price: '₹150',
      quantity: '/250g',
      image: '/product-images/paneer.png',
      details: 'Ayodhya Malai Paneer is crafted using pure milk and traditional techniques to retain its natural softness and fresh milky aroma. Free from preservatives and harmful chemicals, it offers a rich, delicate texture that blends beautifully into both everyday meals and special recipes..',
      benefits: ['Soft, malai-rich texture with a fresh taste', 'Free from preservatives and added chemicals', 'Naturally rich in protein and essential nutrients', 'Perfect for cooking, grilling, or frying', 'Retains its shape while staying tender'],
      availableIn: ['(To be updated as per packaging)'],
      keyIngredients: ['Pure Milk', 'Food-grade Coagulant'],
      directions: ['Rinse in fresh water before use for best texture', 'Ideal for curries, stir-fries, grills, and snacks', 'Can be lightly sautéed or cooked directly in gravies'],
      safety: ['Prepared and packed under hygienic, controlled conditions', 'Store refrigerated at 4°C or below', 'Once opened, consume within the recommended period', 'Do not consume if the pack is damaged or bloated']
    },
    {
      id: 6,
      name: 'Ayodhya Lassi',
      description: 'A refreshing and creamy sweet yogurt drink to cool you down.',
      price: '₹40',
      quantity: '/250ml',
      image: '/product-images/lassi.png',
      details: 'Ayodhya Lassi Premium is crafted from thick, hand-set A2 curd, slowly churnedusing traditional methods to achieve a smooth, velvety texture. Naturally sweetened and delicately infused with Vedic spices, every sip offers rich creaminess and refreshing comfort—just the way authentic lassi is meant to be enjoyed.',
      benefits: ['Crafted from premium A2 curd for superior taste and texture', 'Rich in probiotics that support digestion and gut health', 'Naturally sweetened with no artificial flavors', 'Light, refreshing, and satisfying', 'Perfect balance of tradition and modern convenience'],
      availableIn: ['(To be updated as per packaging)'],
      keyIngredients: ['A2 Curd', 'Natural Sweeteners', 'Selected Vedic Spices'],
      directions: ['Serve chilled for the best taste and freshness', 'Shake well before consumption', 'Ideal as a refreshing drink during the day or after meals'],
      safety: ['Prepared and packed under strict hygienic conditions', 'Store refrigerated at 4°C or below', 'Do not consume if the pack is damaged or bloated', 'Consume within the recommended period mentioned on the pack']
    },
    {
      id: 7,
      name: 'Buttermilk',
      description: 'Traditional spiced buttermilk, perfect for digestion.',
      price: '₹30',
      quantity: '/250ml',
      image: '/product-images/buttermilk.png',
      details: 'Our Refreshing Buttermilk is a traditional, cooling drink crafted to soothe your body and refresh your senses. Light on the stomach and rich in essential nutrients, it’s the perfect everyday companion—especially during warm days or after meals.',
      benefits: ['Excellent source of protein for muscle, skin, and bone health', 'Naturally light and easy to digest', 'Low in fat, making it ideal for daily consumption', 'Rich in essential vitamins for overall wellness', 'Helps keep the body cool and hydrated'],
      availableIn: ['500ml'],
      keyIngredients: ['Cultured Milk (Buttermilk)', 'Natural Curd Culture',],
      directions: ['Consume chilled for the best taste and refreshment', 'Ideal to drink after meals for better digestion', 'Shake well before us'],
      safety: ['Prepared and packed in a hygienic, controlled environment', 'Store refrigerated at 4°C or below', 'Do not consume if the pouch is swollen or damaged', 'Consume within the recommended period mentioned on the pack']
    },
    {
      id: 8,
      name: 'Ayodhya Shrikhand',
      description: 'A delicious and creamy traditional sweet yogurt dessert.',
      price: '₹120',
      quantity: '/250g',
      image: '/product-images/shrikhand.png',
      details: 'Ayodhya Shrikhand is a classic dessert crafted to celebrate indulgence the traditional way. Infused with the aromatic richness of saffron and cardamom, it delivers a smooth, creamy texture and a royal taste that echoes the spiritual and cultural heritage of the city of Ayodhya.',
      benefits: ['Rich, creamy texture with an authentic traditional taste', 'Infused with saffron and cardamom for natural aroma and flavor', 'A perfect blend of indulgence and quality ingredients', 'Ideal for festive occasions and everyday treats', 'Prepared using time-honored methods for consistent richness'],
      availableIn: ['(To be updated as per packaging)'],
      keyIngredients: ['Cultured Milk Solids', 'Natural Sweeteners', 'Saffron', 'Cardamom'],
      directions: ['Serve chilled for the best taste and texture', 'Enjoy as a dessert or festive sweet', 'Can be paired with puri or enjoyed on its own'],
      safety: ['Prepared and packed in hygienic conditions', 'Store refrigerated at 4°C or below', 'Do not consume if the pack is damaged or bloated', 'Consume within the recommended period mentioned on the pack']
    },
    {
      id: 9,
      name: 'Ayodhya Sacred Dhoop',
      description: 'Premium gold collection dhoop for a divine and calming atmosphere.',
      price: '₹150',
      quantity: '/Pack',
      image: '/product-images/dhoopmoksha.png',
      details: 'Ayodhya Sacred Dhoop is a soulful offering crafted to bring the sanctity of the Mandir into your home. Made using the very flowers offered in worship to Lord Ram, this premium dhoop transforms devotion into a divine fragrance, allowing every prayer to feel deeper and more meaningful.',
      benefits: ['Made from sacred temple flowers, giving them a second life', 'Creates a calming, spiritually uplifting atmosphere', 'Long-lasting, soothing fragrance for daily worship', 'Enhances focus, peace, and mindfulness during prayers', 'A conscious blend of devotion and sustainability'],
      availableIn: ['(To be updated as per packaging)'],
      keyIngredients: ['Recycled Temple Flowers', 'Natural Aromatic Resins', 'Herbal & Botanical Ingredients'],
      directions: ['Light the tip of the dhoop', 'Place in a holder', 'Keep in a well-ventilated area'],
      safety: ['Use in a well-ventilated area', 'Keep away from flammable materials', 'Do not leave unattended while burning', 'Keep out of reach of children and pets']
    },
    {
      id: 10,
      name: 'Ayodhya Pure Dhoop',
      description: 'Traditional dhoop for daily spiritual rituals and a peaceful home.',
      price: '₹80',
      quantity: '/Pack',
      image: '/product-images/dhooptraditional.png',
      details: 'Ayodhya Pure Dhoop is crafted to bring the calm and purity of nature into your prayer room. Made using 100% natural ingredients, this premium dhoop releases a long-lasting, soul-stirring fragrance that creates a serene and spiritually uplifting environment for daily worship and meditation.',
      benefits: ['100% natural formulation with no synthetic additives', 'Long-lasting fragrance that soothes the senses', 'Creates a peaceful and sacred atmosphere', 'Ideal for daily prayers, meditation, and spiritual rituals', 'Gentle, non-overpowering aroma'],
      availableIn: ['(To be updated as per packaging)'],
      keyIngredients: ['Natural Resins', 'Herbal & Botanical Extracts', 'Plant-based Aromatic Oils'],
      directions: ['Light the dhoop cone or stick carefully', 'Place on a heat-resistant holder', 'Allow the fragrance to fill the prayer space naturally'],
      safety: ['Use in a well-ventilated area', 'Keep away from flammable materials', 'Do not leave burning dhoop unattended', 'Keep out of reach of children and pets']
    },
    {
      id: 11,
      name: 'Ayodhya Go Clean Pro',
      description: 'High-quality cleaning phenyle for a germ-free and fresh home.',
      price: '₹100',
      quantity: '/1L',
      image: '/product-images/gocleanphenyle.png',
      details: 'Ayodhya GoClean Pro is more than a product—it is a promise of lifelong care for our desi cows. Every purchase directly contributes to providing shelter, safety, and dignity to cows even after their milking years are over. Through this initiative, Ayodhya supports cow shelters that protect these sacred animals from neglect and abandonment.',
      benefits: ['Supports lifelong care and shelter for desi cows', 'Helps protect cows from neglect after their productive years', 'Promotes ethical, responsible dairy practices', 'Allows consumers to participate in animal welfare', 'Creates meaningful impact with every purchase'],
      availableIn: ['1L', '5L'],
      keyIngredients: ['Disinfectants', 'Fragrance', 'Cleaning Agents'],
      directions: ['Dilute with water for mopping', 'Use directly on tough stains'],
      safety: ['Keep out of reach of children', 'For external use only', 'Harmful if swallowed']
    }
  ];

  const [accordionsOpen, setAccordionsOpen] = useState({
    benefits: true,
    availableIn: false,
    keyIngredients: false,
    directions: false,
    safety: false
  });

  React.useEffect(() => {
    return () => {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, []);

  const toggleAccordion = (key) => {
    setAccordionsOpen(prev => ({ ...prev, [key]: !prev[key] }));
  };
  

  const openModal = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
    document.body.classList.add('modal-open');
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = 'var(--scrollbar-width, 0px)'; // Prevent layout shift
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  return (
    <section id="products" className="products">
      <div className="products-container">
        <div className="products-header">
          <h2 className="section-title">Sacred Dairy Products</h2>
          <p className="section-subtitle">
            Crafted with devotion, delivered with care. Each product embodies the purity and tradition of Ayodhya.
          </p>
        </div>
        <div className="products-grid">
          {products.map((product) => (
            <div 
              key={product.id} 
              className="product-card"
              onClick={() => openModal(product)}
            >
              <div className="product-image">
                {product.image.startsWith('/') ? (
                  <img 
                    src={product.image} 
                    alt={product.name} 
                    className="product-img" 
                    loading="lazy" 
                    decoding="async"
                  />
                ) : (
                  <span className="product-emoji">{product.image}</span>
                )}
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Product Detail Modal */}
      {isModalOpen && selectedProduct && (
        <div className="product-modal-overlay" onClick={closeModal}>
          <div className="product-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            <div className="modal-content">
              <div className="modal-image">
                {selectedProduct.image.startsWith('/') ? (
                  <img 
                    src={selectedProduct.image} 
                    alt={selectedProduct.name} 
                    className="modal-img" 
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  <span className="modal-emoji">{selectedProduct.image}</span>
                )}
              </div>
              <div className="modal-info">
                <h2 className="modal-title">{selectedProduct.name}</h2>
                <p className="modal-description">{selectedProduct.description}</p>
                <div className="modal-details">
                  <h3>Product Details</h3>
                  <p>{selectedProduct.details}</p>
                </div>
                <div className="accordion">
                  <div className="accordion-item">
                    <button className="accordion-header" onClick={() => toggleAccordion('availableIn')}>
                      <span>Available In</span>
                      <span className={accordionsOpen.availableIn ? 'accordion-icon open' : 'accordion-icon'}>▾</span>
                    </button>
                    <div className={accordionsOpen.availableIn ? 'accordion-body open' : 'accordion-body'}>
                      <ul>
                        {selectedProduct.availableIn.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <button className="accordion-header" onClick={() => toggleAccordion('benefits')}>
                      <span>Key Benefits</span>
                      <span className={accordionsOpen.benefits ? 'accordion-icon open' : 'accordion-icon'}>▾</span>
                    </button>
                    <div className={accordionsOpen.benefits ? 'accordion-body open' : 'accordion-body'}>
                      <ul>
                        {selectedProduct.benefits.map((benefit, index) => (
                          <li key={index}>{benefit}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <button className="accordion-header" onClick={() => toggleAccordion('keyIngredients')}>
                      <span>Key Ingredient</span>
                      <span className={accordionsOpen.keyIngredients ? 'accordion-icon open' : 'accordion-icon'}>▾</span>
                    </button>
                    <div className={accordionsOpen.keyIngredients ? 'accordion-body open' : 'accordion-body'}>
                      <ul>
                        {selectedProduct.keyIngredients.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <button className="accordion-header" onClick={() => toggleAccordion('directions')}>
                      <span>Direction for Use</span>
                      <span className={accordionsOpen.directions ? 'accordion-icon open' : 'accordion-icon'}>▾</span>
                    </button>
                    <div className={accordionsOpen.directions ? 'accordion-body open' : 'accordion-body'}>
                      <ul>
                        {selectedProduct.directions.map((step, index) => (
                          <li key={index}>{step}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <button className="accordion-header" onClick={() => toggleAccordion('safety')}>
                      <span>Safety Information</span>
                      <span className={accordionsOpen.safety ? 'accordion-icon open' : 'accordion-icon'}>▾</span>
                    </button>
                    <div className={accordionsOpen.safety ? 'accordion-body open' : 'accordion-body'}>
                      <ul>
                        {selectedProduct.safety.map((note, index) => (
                          <li key={index}>{note}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Products;
